import { render } from "./recomendation.vue?vue&type=template&id=0f592430&lang=html"
import script from "./recomendation.vue?vue&type=script&lang=js"
export * from "./recomendation.vue?vue&type=script&lang=js"

import "./recomendation.vue?vue&type=style&index=0&id=0f592430&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__